// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","PlaceholderWrapper":"PlaceholderWrapper-3ftuqxctuzv94jhwhbgsxfbkaw1y8vzd4h9hvgt3u9ars4y3qntn7ha2tyd5d1vcyutywb5dw9vg7y4wcqm18b9tpmad37pf9u3vqgk","pulse":"pulse-kemtvzzsbuefjy5r4qut9y1r1smefd9yr67mkmdbgydm1579s12xyxm5pw3wr8sn5f3pzkyx44ph1kjnxmv2r1q1gwdqvpv89c5qrx","loading":"loading-2vwsbs9ume95pcuvpshsby99gr3ncghfgn57gyudah9hs7jtm156xs34ajp4ckxz7k2sssw629ka8n3zxp7qa5ty878unbp2mdqrydd"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/Placeholder/Placeholder.module.scss
// module id = 1307
// module chunks = 0